<template>
<div class="drawerWrap picAddOrEdit">
  <div class="drawerBody">
    <el-form class="drawerForm" ref="form" :model="form" :rules="formRules" label-width="80px">
      <el-form-item prop="serial" label="序号">
        <el-input-number v-model="form.serial" :min="1" :max="9" label="请输入序号"></el-input-number>
      </el-form-item>
      <el-form-item prop="title" label="名称">
        <!-- <el-input v-model.trim="form.title" minlength="1" maxlength="15" placeholder="请输入名称" @keyup.native="form.title=form.title.replace(/\s+/g,'')"></el-input> -->
        <el-input v-model.trim="form.title" minlength="1" maxlength="15" placeholder="请输入名称"></el-input>
      </el-form-item>
      <el-form-item prop="file" label="图片">
        <el-upload :class="{'demo-httpRequestImg':httpRequestImg}" action :disabled="drawer.type == 'edit'" :limit="1" :before-upload="beforeAvatarUpload" list-type="picture-card" :http-request="handleHttpRequest" :on-preview="handlePictureCardPreview" :file-list="fileList" :on-remove="handleRemove">
          <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :append-to-body='true' :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
        <p v-if="drawer.type == 'edit'" class="tip">注：若要修改图片，请删除该整条信息后重新添加</p>
      </el-form-item>
      <el-form-item prop="targetUrl" label="链接">
        <el-input v-model.trim="form.targetUrl" minlength="1" placeholder="请输入点击图片后的跳转链接" @keyup.native="form.title=form.title.replace(/\s+/g,'')"></el-input>
      </el-form-item>
    </el-form>
  </div>
  <div class="drawerFoot">
    <div class="right-btn">
      <el-button type="primary" @click="handleConfirm" :loading="isSave">提交</el-button>
      <el-button type="info" plain @click="handleCancel">取消</el-button>
    </div>
  </div>
</div>
</template>

<script>
export default {
  props: {
    drawer: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      form: {},
      formRules: {
        serial: [{
          required: true,
          validator: this.validateDeviceSerial,
          trigger: "blur"
        }],
        file: [{
          required: true,
          message: "必填"
        }],
        title: [{
          required: true,
          validator: this.validatePicName,
          trigger: "blur"
        }],
        targetUrl: [{
          required: false,
          validator: this.validateDevicetargetUrl,
          trigger: "blur"
        }],
      },
      dialogImageUrl: '',
      fileList: [],
      httpRequestImg: false, //展示单个图片
      dialogVisible: false,
      isSave: false,
      tagUrl: 0
    }
  },
  mounted() {
    this.form = this.drawer.data

    let file = {
      name: this.drawer.data.picName,
      url: `${this.baseUrlAddr}/front/picUploadAndDownload/download?fileName=${this.drawer.data.picName}`
    }
    if (this.drawer.type === 'edit') {
      this.fileList.push(file)
      this.httpRequestImg = true
    }
  },
  methods: {
    validateDeviceSerial(rule, value, callback) {
      if (!value) callback(new Error("不能为空"));
    },
    validateDeviceFlie(rule, value, callback) {
      if (!value) callback(new Error("不能为空"));
    },
    validatePicName(rule, value, callback) {
      if (value === "" || value === null) {
        callback(new Error("轮播图名称不能为空"));
      } else {
        callback()
      }
    },
    validateDevicetargetUrl(rule, value, callback) {
      this.tagUrl = 0
      if (value) {
        var regUrl = new RegExp('[a-zA-z]+://[^\s]*');
        var result = regUrl.test(value);
        if (result != 1) {
          callback(new Error("格式错误，例:http://xxx"));
          this.tagUrl = 1
        }
      }
    },
    //对上传图片的大小、格式进行限制
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isJPG2 = file.type === "image/jpg";
      const isPNG = file.type === "image/png";
      const isLt5M = file.size / 1024 / 1024 < 1;
      if (!isJPG && !isJPG2 && !isPNG) {
        this.$message.warning("只支持jpeg或jpg或png格式图片");
      }
      if (!isLt5M) {
        this.$message.warning("请上传1MB以内的图片!");
      }
      return (isJPG || isJPG2 || isPNG) && isLt5M;
    },
    handlePictureCardPreview(file) {
      console.log(file);
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleRemove(file, fileList) {
      this.httpRequestImg = false;
      this.dialogImageUrl = "";
      this.fileList = [];
      this.form.file = null
    },
    handleHttpRequest(obj) {
      this.httpRequestImg = true;
      this.form.file = obj.file;
      this.msg.success('图片上传成功')
    },
    handleConfirm() {
      let type = this.drawer.type
      let {
        file,
        serial,
        title,
        targetUrl
      } = this.form

      if (!serial || !title || this.tagUrl) return this.msg.error("请按要求完善表单信息");

      if (type == 'add') {
        if (!file) return this.msg.error("请上传图片！");
        let formData = new FormData();
        formData.append("file", file);

        this.isSave = true
        this.request.post(`/admin/rotationPic/add?serial=${serial}&title=${title}&targetUrl=${targetUrl}`, formData).then(res => {
          this.isSave = false
          if (res.code == 200) {
            this.msg.success('添加成功');
            this.$emit('handleConfirm')
          } else {
            this.msg.error(res.msg);
          }
        })
      } else if (type == 'edit') {
        let params = {
          id: this.form.id,
          serial,
          title,
          targetUrl
        }

        this.isSave = true
        this.request.postFormData("/admin/rotationPic/edit", params).then(res => {
          this.isSave = false

          if (res.code == 200) {
            this.msg.success('编辑成功')
            this.$emit('handleCancel')
          } else {
            this.msg.error(res.msg);
          }
        });
      }
    },
    handleCancel() {
      this.$emit('handleCancel')
    }
  }
}
</script>

<style lang="scss" scoped>
// .content-panel {
//   position: relative;
//   display: inline-block;
//   width: 100%;
// }
// .privilege-form-item {
//   padding: 0 10px;
// }
.picAddOrEdit {
  .drawerFoot {
    .right-btn {
      float: right;
      margin-right: 30px;
    }
  }

  .el-input-number {
    width: 268px;
  }

  .tip {
    color: #999;
    font-size: 12px;
  }
}
</style>
